import React, { Component } from 'react';
import './checkbox.scss';

import { joinClasses } from '../../../utils/helpers';

/** @import {CheckboxProps, CheckboxState} from './CheckboxTypes' */

let nextInputId = 1;

/** @extends {Component<CheckboxProps>} */
class Checkbox extends Component {
  /** @type {CheckboxState} */
  state = {
    checked: false
  };

  constructor(/** @type {CheckboxProps} */ props) {
    super(props);

    this.inputId = `checkbox-${nextInputId++}`;

    this.state = {
      checked: props.checked || false
    }
  }

  static getDerivedStateFromProps(/** @type {CheckboxProps} */ props) {
    if (!props.hasOwnProperty('checked')) return null;
    return {
      checked: props.checked || false
    };
  }

  handleChange = (/** @type {React.ChangeEvent<HTMLInputElement>} */ e) => {
    if (this.props.disabled) return;

    const newChecked = e.target.checked;
    this.setState({ checked: newChecked }, () => {
      if (this.props.onChange) {
        this.props.onChange(newChecked);
      }
    });
  }

  getClassNames() {
    return joinClasses(
      'checkbox',
      this.props.className
    );
  }

  render() {
    const { name, disabled, label, value } = this.props;
    const { checked } = this.state;

    return (
      <label
        className={this.getClassNames()}
        htmlFor={this.inputId}
      >
        <input
          id={this.inputId}
          className='checkbox__input'
          type='checkbox'
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={this.handleChange}
        />
        <div className='checkbox__indicator' />
        <p className='checkbox__label'>
          {label}
        </p>
      </label>
    );
  }
}

export default Checkbox;
